<div class="bg-th-blue mt-0 container-fluid py-2">

    <div class=" d-flex justify-content-between align-content-center">

        <i class="fa fa-arrow-left text-secondary my-auto pointer text-white" [routerLink]="['/']"></i>

        <a class=" d-flex align-items-center  text-secondary f18 my-auto text-white">

            <span> مسیرهای ترانزیت </span>

        </a>

    </div>

</div>

<main class="px-2" style="direction: rtl;">

    <div [formGroup]="mdl_Request" class="border border-2 container-fluid row gx-2 gy-2 mt-3 p-2">

        <!-- جستجو -->

        <div class="col-12 col-md-9">

            <input type="text" class="w-100 form-control" placeholder="جستجو کنید ..."
                (input)="filter_Result($event.target)">

        </div>

        <!-- افزودن -->

        <div class="col-12 col-md-auto d-flex align-items-center">

            <button class="btn btn-primary w-100" (click)="addRequest()">

                افزودن

            </button>

        </div>

        <!-- خروجی اکسل -->

        <div class="col-12 col-md-auto d-flex align-items-center">

            <button class="btn btn-success w-100" (click)="exportexcel('Export_Excel')"> خروجی اکسل </button>

        </div>

        <!-- جدول اطلاعات -->

        <div class="section border border-2 mt-2">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                <thead>

                    <tr class="text-center">

                        <th scope="col" class="">#</th>

                        <th scope="col" class=""> عملیات </th>

                        <th scope="col" class="pointer"> عنوان </th>

                        <th scope="col" class=""> نام محدوده مبداء </th>

                        <th scope="col" class=""> نام محدوده مقصد </th>

                        <th scope="col" class="pointer"> مدت سفر(دقیقه) </th>

                        <th scope="col" class="pointer"> مدت توقف(دقیقه) </th>


                    </tr>

                </thead>

                <tbody>

                    <tr class="f14 text-center" *ngFor="let item of lst_Routes;let i=index">

                        <th class="text-dark">{{ i + 1 | faNum }}</th>

                        <th class="">

                            <i class="text-danger fa fa-trash fa-lg pointer" (click)="removeRoute(item,i)"></i>

                            <i class="text-primary mx-2 fa fa-pencil-square-o fa-lg pointer" (click)="addRequest(item,i)"></i>

                        </th>

                        <td> {{ item.strTitle | faNum }} </td>

                        <td> {{ item.strSGeoFence_strTitle | faNum }} </td>

                        <td> {{ item.strDGeoFence_strTitle | faNum }} </td>

                        <td> {{ item.iTripTime | faNum }} </td>

                        <td> {{ item.iStopTime | faNum }} </td>

                    </tr>

                </tbody>

            </table>

        </div>

    </div>

</main>

<!-- مدال افزودن، ویرایش -->

<div class="modal fade" id="addModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> {{ bEditMode ? 'ویرایش' : 'افزودن' }} </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div [formGroup]="mdl_Request" class="row gx-0 gy-0">

                    <!-- عنوان -->

                    <div class="col-12">

                        <div class="position-relative w-100 h-100 p-2">

                            <label class="mb-2 text-muted"> عنوان </label>

                            <input class="form-control p-2 text-center" formControlName="strTitle">

                        </div>

                    </div>

                    <!-- محدوده مبداء -->

                    <div class="col-md-6 col-12">

                        <div class="position-relative w-100 h-100 p-2">

                            <label class="mb-2 text-muted"> محدوده مبداء </label>

                            <select class="form-select p-2" formControlName="iSGeoFence">

                                <option class="text-center" value=""> انتخاب کنید </option>

                                <option class="text-center" *ngFor="let item of lst_GeoFence" [value]="item.iGeoFence">

                                    {{ item.strTitle }}

                                </option>

                            </select>

                        </div>

                    </div>

                    <!-- محدوده مقصد -->

                    <div class="col-md-6 col-12">

                        <div class="position-relative w-100 h-100 p-2">

                            <label class="mb-2 text-muted"> محدوده مقصد </label>

                            <select class="form-select p-2" formControlName="iDGeoFence">

                                <option class="text-center" value=""> انتخاب کنید </option>

                                <option class="text-center" *ngFor="let item of lst_GeoFence" [value]="item.iGeoFence">

                                    {{ item.strTitle }}

                                </option>

                            </select>

                        </div>

                    </div>

                    <!-- مدت سفر(دقیقه) -->

                    <div class="col-md-6 col-12">

                        <div class="position-relative w-100 h-100 p-2">

                            <label class="mb-2 text-muted"> مدت سفر(دقیقه) </label>

                            <input class="form-control p-2 text-center" oninput="this.value = this.value.replace(/[^0-9]/g,'')" formControlName="iTripTime">

                        </div>

                    </div>

                    <!-- مدت توقف(دقیقه) -->

                    <div class="col-md-6 col-12">

                        <div class="position-relative w-100 h-100 p-2">

                            <label class="mb-2 text-muted"> مدت توقف(دقیقه) </label>

                            <input class="form-control p-2 text-center" oninput="this.value = this.value.replace(/[^0-9]/g,'')" formControlName="iStopTime">

                        </div>

                    </div>

                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn" [ngClass]="bEditMode ? 'btn-primary' : 'btn-success' " (click)="submitRequest()">

                    &nbsp; {{ bEditMode ? 'ویرایش' : 'ذخیره' }}  &nbsp;

                </button>

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>